export const replaceJSX = (string, findArray, replaceArray) => {
  let result = [string];

  findArray.forEach((find, index) => {
    const replace = replaceArray[index];
    result = result.flatMap((item) =>
      typeof item === "string"
        ? item
            .split(find)
            .flatMap((part, i, arr) =>
              i < arr.length - 1 ? [part, replace] : [part]
            )
        : [item]
    );
  });

  return result;
};
